import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=766c5531&scoped=true"
import script from "./pc-sheet.ts?vue&type=script&lang=ts&external"
export * from "./pc-sheet.ts?vue&type=script&lang=ts&external"
import style0 from "./sheet.vue?vue&type=style&index=0&id=766c5531&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766c5531",
  null
  
)

export default component.exports